module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("01Ax2"))).then(() => parcelRequire('d0iPb'));